<!-- container-xxl -->
<div class="content-wrapper p-0">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="content-body">
      <!-- app e-commerce details start -->
      <section class="app-ecommerce-details">
           <!-- <h5><b>For any issue related to the Portal, kindly write us a info[dot]mnre[at]ahasolar[dot]in <br> </b> </h5>
		   	<br>
		   	<p>
				<b>Mobile:-</b> 95493 83730 <br>
				<b>Email:-</b> kushank[dot]p[at]ahasolar[dot]in
			</p> -->
			<br />
           <!-- <h5><b>For any further clarification and online submission of the proposal:</b> contact the following;</h5> -->
            <p class="mb-0">1. Dr. Arun Kumar Tripathi </p> 
            <p class="mb-0">Scientist-G</p>  
            <p class="mb-0">Email ID: aktripathi[at]nic[dot]in </p>
            <p class="mb-0">Contact Number: +91-011-20849145 </p> <br />

            <p class="mb-0">2. Dr. Anil Kumar</p> 
            <p class="mb-0">Scientist-D</p>
            <p class="mb-0">Email ID: anil[dot]kumar[dot]mnre[at]nic[dot]in</p>
            <p class="mb-0">Contact Number:  +91-011-20849144,</p>   <br />

            <p class="mb-0">3. Ms. Priya</p> 
            <p class="mb-0">Scientist-D</p>
            <p class="mb-0">Email ID: priya[dot]mnre[at]gov[dot]in</p>
            <p class="mb-0">Contact Number:  N/A</p>   <br />

            <p class="mb-0">4. Arun K.  Choudhary</p> 
            <p class="mb-0">Scientist-C</p>
            <p class="mb-0">Email ID: akchoudhary[dot]mnre[at]gov[dot]in</p>
            <p class="mb-0">Contact Number:  N/A</p>   <br />
            

          <!-- </div> -->
        <!-- </div> -->
      </section>
    </div>
  </div>
  